import DOMPurify from 'dompurify';
import { cn } from '@eureca/ui';

/**
 * EU-556 (QA) — corpo de resposta de FAQ autorado no RichTextEditor (Tiptap →
 * HTML). Antes era interpolado como TEXTO (`{faq.answer}`) e o consultor via as
 * tags cruas (`<p>lorem</p>`). Renderiza o HTML SANEADO (DOMPurify remove
 * scripts/handlers/iframes) via `dangerouslySetInnerHTML` — paridade com o
 * render do candidato (`sanitize-html.ts` + classes de prosa, V44).
 */
export function RichTextContent({ html, className }: { html: string; className?: string }) {
  return (
    <div
      className={cn(
        'text-sm leading-5 text-foreground',
        '[&_p]:min-h-[1.25rem] [&_a]:text-primary [&_a]:underline [&_a]:underline-offset-2',
        '[&_ul]:list-disc [&_ul]:pl-5 [&_ol]:list-decimal [&_ol]:pl-5 [&_strong]:font-semibold',
        className
      )}
      dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html) }}
    />
  );
}
